import { Link } from "react-router-dom";
import { Hospital, Stethoscope, Handshake, TrendUp, ArrowUpRight } from "@phosphor-icons/react";
import { Reveal, SectionHeading } from "../Reveal";

const AUDIENCES = [
    {
        icon: Hospital,
        title: "Hospitals",
        text: "Join our healthcare provider network.",
        cta: "Partner With Us",
        to: "/partner",
        testid: "partner-cta-hospitals",
    },
    {
        icon: Stethoscope,
        title: "Healthcare Professionals",
        text: "Help us build a trusted global healthcare ecosystem.",
        cta: "Connect With Us",
        to: "/contact",
        testid: "partner-cta-professionals",
    },
    {
        icon: Handshake,
        title: "Strategic Partners",
        text: "Explore opportunities across technology, travel, insurance and healthcare.",
        cta: "Let's Collaborate",
        to: "/contact",
        testid: "partner-cta-strategic",
    },
    {
        icon: TrendUp,
        title: "Investors",
        text: "Join us in building the infrastructure for global healthcare access.",
        cta: "Connect With the Founding Team",
        to: "/contact",
        testid: "partner-cta-investors",
    },
];

export default function PartnerCTA() {
    return (
        <section data-testid="partner-cta-section" className="py-28 lg:py-36 bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <SectionHeading
                    chapter="14"
                    eyebrow="Join Us"
                    title="Let's build the future of cross-border healthcare together."
                    testid="partner-cta-heading"
                />
                <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {AUDIENCES.map((a, i) => (
                        <Reveal key={a.title} delay={0.08 * i}>
                            <Link
                                data-testid={a.testid}
                                to={a.to}
                                className="group flex h-full flex-col rounded-3xl border border-slate-100 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:-translate-y-1.5 hover:border-brand-green/30 hover:shadow-[0_24px_48px_rgb(13,148,136,0.12)] transition-[transform,box-shadow,border-color] duration-300"
                            >
                                <div className="w-12 h-12 rounded-2xl bg-tint-blue flex items-center justify-center text-brand-blue group-hover:bg-brand-blue group-hover:text-white transition-colors duration-300">
                                    <a.icon size={24} weight="duotone" />
                                </div>
                                <h3 className="mt-6 font-heading text-xl font-semibold text-brand-blue">{a.title}</h3>
                                <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{a.text}</p>
                                <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-brand-green">
                                    {a.cta}
                                    <ArrowUpRight size={16} weight="bold" className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" />
                                </span>
                            </Link>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
